<template>
  <footer class="bg-dark text-light py-4 mt-5">
    <b-container>
      <b-row>
        <b-col md="4">
          <h5>Sobre Nosotros</h5>
          <p class="text-muted">
            {{ config && config.about_text ? config.about_text : 'Tu tienda online de confianza' }}
          </p>
        </b-col>
        
        <b-col md="4">
          <h5>Contacto</h5>
          <ul class="list-unstyled text-muted">
            <li v-if="config && config.contact">
              <b-icon icon="envelope"></b-icon> {{ config.contact.email }}
            </li>
            <li v-if="config && config.contact">
              <b-icon icon="telephone"></b-icon> {{ config.contact.phone1 }}
            </li>
            <li v-if="config && config.contact && config.contact.address">
              <b-icon icon="geo-alt"></b-icon> {{ config.contact.address }}
            </li>
          </ul>
        </b-col>
        
        <b-col md="4">
          <h5>Síguenos</h5>
          <div class="social-links">
            <a v-if="config && config.social && config.social.facebook" 
               :href="config.social.facebook" 
               target="_blank" 
               class="text-light mr-3">
              <b-icon icon="facebook" font-scale="1.5"></b-icon>
            </a>
            <a v-if="config && config.social && config.social.instagram" 
               :href="config.social.instagram" 
               target="_blank" 
               class="text-light mr-3">
              <b-icon icon="instagram" font-scale="1.5"></b-icon>
            </a>
            <a v-if="config && config.social && config.social.twitter" 
               :href="config.social.twitter" 
               target="_blank" 
               class="text-light mr-3">
              <b-icon icon="twitter" font-scale="1.5"></b-icon>
            </a>
          </div>
        </b-col>
      </b-row>
      
      <hr class="bg-secondary">
      
      <b-row>
        <b-col class="text-center text-muted">
          <p class="mb-0">
            &copy; {{ new Date().getFullYear() }} {{ shopName }}. Todos los derechos reservados.
          </p>
          <small>Powered by ESCALITY</small>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      shopName: 'ESCALITY Shop'
    }
  },
  computed: {
    config() {
      return this.$store.getters.shopConfig
    }
  }
}
</script>

<style scoped>
footer {
  margin-top: auto;
}

.social-links a:hover {
  opacity: 0.8;
}
</style>